import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const Logout = ({ user }) => {
	const navigate = useNavigate();

	useEffect(() => {
		user.resetSession();
		navigate('/login', { replace: true });
	}, []);
	return <></>;
};

Logout.propTypes = {
	user: PropTypes.object.isRequired,
};

export default Logout;
